exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-grid-menu-column[data-v-c3135e14] {\n  display: none;\n}\n", ""]);

// exports
